// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8305c28e","455":"68f84dd2","977":"dc546841"}[chunkId] + ".chunk.js";
};